module.exports = __webpack_public_path__ + "img/05.5aedbff4.jpg";